<template>
   <div>
        <Breadcrumb :headers="headers"></Breadcrumb>
        <List 
            url="getSaleLeadsList"
            deleteUrl="deleteSaleLeads" 
            :data="searchData" 
            :tanle="tanle" 
            :update="updateList" 
            :afterList="dealListData"
            :operat="operat"
            @add="add"
            @edit="edit"
            @info="info"
            @setStatus="setStatus"
            :isAdd="this.type === '0' || this.type === '1' || this.type === '2'"
            >
            <div slot="Filter">
                <label style="margin-left:10px;">Sale Leads Status：</label>
                <el-select v-model="searchData.Status" placeholder="">
                    <el-option
                        v-for="item in statusList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>

                <el-input v-model="searchData.Key" placeholder="Company Name" style="width:300px;margin-left:20px;"></el-input>
                <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
            </div>
        </List>
    
        <SetStatusBox :id="statusForm.id" :status="statusForm.Status" v-if="statusBlock" @close="statusBlock = false" @update="updateList++"></SetStatusBox>
   </div>
</template>
<script>
import List from "../components/common/List.vue";
import SetStatusBox from "@/components/SaleLeads/SetStatusBox.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
import { ORDERSTATUS,orderStatusList } from "@/components/SaleLeads/data.js";
import { unshiftAll } from "@/methods/selection.js";
export default {
    components:{
        List,
        SetStatusBox,
        Breadcrumb
    },
    data () {
        return {
            tanle: [
                {name:"CompanyName",label:"Company Name"},{name:"Country",label:"Country"},{name: "PartnerCompanyName", label: "Partner" },{name: "ContactInfo", label: "ContactInfo" },
                /* {name: "NotefromSales", label: "Note from Sales" }, */{name:"ExpectDate",label:"Expect Date"},{name:"StatusName",label:"Status"}
            ],
            headers:[{label:"Home",path:"/dashboard"},{label:"Sale Leads",path:"/saleLeads"}],
            searchData:{
                Key:"",
                Status:"all"
            },
            type:"",
            updateList:0,
            updateType: "add",
            updateForm: {},
            updateBlock: false,
            statusList:unshiftAll(orderStatusList),
            operat:[],
            statusForm:{
                id:"",
                Status:""
            },
            statusBlock:false,
            customerList:[]
        };
    },
    mounted () {
        this.type = localStorage.getItem("type");
        
        if (this.type === 'null' || this.type === '1' || this.type === '2')
        {
            this.operat.push(  {
                text:"Status",
                eventName:"setStatus",
                type:'danger',
                method (data) {
                    return (data.Status !== "2"  );
                }
            });
        }
         
        if (this.type === '0' || this.type === '1' || this.type === '2')
        {
            this.operat.push(  {
                text: "Delete",
                eventName: "delete",
                type: "danger",
                PretreatMethod: "confirmDelete"
            });
            this.operat.push(  {
                text:"Edit",
                eventName:"edit",
                type:'primary',
                method (data) {
                    return (data.Status !== "2");
                } 
            });
        }
        if (this.type === 'null' || this.type === '0' || this.type === '1' || this.type === '2')
        {
            this.operat.push(  {
                text:"Info",
                eventName:"info",
                type:'primary'/* ,
                method (data) {
                    return (data.Status !== "1");
                }  */
            });
        }
      
    },
    methods:{
        dealListData (data) {
            for(let i in data) {
                data[i].StatusName = ORDERSTATUS[data[i].Status];
                data[i].ExpectDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(data[i].ExpectTime);
                data[i].ExpectDate = data[i].ExpectDate[0];
                data[i].ExpectDate = data[i].ExpectDate.replace(/"/g, "");
            }
            return data;
        },
        /*  add () {
            this.updateForm = {
                ExpectTime:"",
                CompanyName:"",
                Description:"",
                Location:"",
                Partner:""
            };
            this.updateType = "add";
            this.updateBlock = true;
        },
        edit (val) {
            this.updateForm = val;
            this.updateForm.ExpectTime = new Date(val.ExpectTime); 
            this.updateType = "edit";
            this.updateBlock = true;
        }, */
        add () {
            this.$router.push("/saleLeadsUpdate");
        },
        edit (val) {
            this.$router.push(`/saleLeadsUpdate?id=${val.ID}`);   
        },
        info (val) {
            this.$router.push(`/saleLeadsInfo?id=${val.ID}`);   
        },
        setStatus (val) {
            this.statusForm.id = val.ID;
            this.statusForm.Status = val.Status;
            this.statusBlock = true;
        }
    }
};
</script>
